import { render, staticRenderFns } from "./network-offline.vue?vue&type=template&id=1a90cdf9&"
var script = {}
import style0 from "./network-offline.vue?vue&type=style&index=0&id=1a90cdf9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports